import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getAccessToken } from '../services/authService';
import useAuth from '../context/AuthContext';

const Callback = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { authSetToken } = useAuth();

  useEffect(() => {
    // Extract query parameters from the location.search (URL query string)
    const urlParams = new URLSearchParams(location.search);

    // Extract the parameters
    const code = urlParams.get('code');
    const userState = urlParams.get('userState');
    const codeVerifier = localStorage.getItem('code_verifier');

    if (code) {
      localStorage.setItem('code', code);
    }

    if (code && (userState === 'Authenticated' || userState === 'AuthenticatedNotRegistered')) {
      getAccessToken(code, codeVerifier || '')
        .then((access_token) => {
           authSetToken(access_token);
           setLoading(false);
           navigate('/dashboard');
        })
        .catch(() => console.log("error"));
    } else {
      setLoading(false);
      navigate('/');
    }
  }, []);

  return (
    <>
      {loading ? (
        <div className="center">
          <div className="loader"></div>
        </div>
      ) : (
        <div>Redirecting...</div>
      )}
    </>
  );
};

export default Callback;
